import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Nav, Navbar, NavDropdown, Button } from "react-bootstrap";

import Enquire_from_modal from "../common-components/common_modal/enquire_from_modal/Enquire_from_modal";
import { getProducts } from "../../utils/apis/products/Product";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const [categories, setCategories] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setProductsLoading(true);

      const res = await getProducts();

      if (res?.success && Array.isArray(res?.data)) {
        const uniqueCategories = [
          ...new Map(
            res.data
              .filter((item) => item?.Category)
              .map((item) => [item.Category.id, item.Category]),
          ).values(),
        ];

        setCategories(uniqueCategories);
      } else {
        setCategories([]);
      }
    } catch (error) {
      console.log("Error fetching products for header:", error);
      setCategories([]);
    } finally {
      setProductsLoading(false);
    }
  };

  const handleNavClick = () => {
    setExpanded(false);
  };

  const handleCategoryClick = (categoryId) => {
    setExpanded(false);

    navigate(`/products/${categoryId}`);
  };

  return (
    <section className="header_section">
      <Navbar
        expand="lg"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <div className="container">
          {/* ================= LOGO ================= */}
          <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
            <img
              className="logo-img"
              src={process.env.PUBLIC_URL + "/assets/images/logo/seedso2.png"}
              alt="Seedso"
            />
          </Navbar.Brand>

          <div className="enquire_btn_wrapper mobile">
            <Button
              className="enquire_btn"
              onClick={() => {
                setModalShow(true);
                setExpanded(false);
              }}
            >
              Enquire
            </Button>
          </div>

          <Navbar.Toggle aria-controls="navbar" />

          <Navbar.Collapse id="navbar">
            <Nav className="mx-auto align-items-lg-center">
              {/* HOME */}
              <Nav.Link as={Link} to="/" onClick={handleNavClick}>
                Home
              </Nav.Link>

              {/* PRODUCTS DROPDOWN  */}
              <NavDropdown
                title="Products"
                id="products-dropdown"
                menuVariant="light"
              >
                {productsLoading && (
                  <NavDropdown.Item disabled>
                    Loading categories...
                  </NavDropdown.Item>
                )}

                {!productsLoading &&
                  categories.length > 0 &&
                  categories.map((category) => (
                    <NavDropdown.Item
                      key={category.id}
                      onClick={() => handleCategoryClick(category.id)}
                    >
                      {category.name}
                    </NavDropdown.Item>
                  ))}

                {!productsLoading && categories.length === 0 && (
                  <NavDropdown.Item disabled>
                    No categories available
                  </NavDropdown.Item>
                )}

                <NavDropdown.Divider />

                <NavDropdown.Item
                  as={Link}
                  to="/products"
                  onClick={handleNavClick}
                >
                  View All Products →
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={Link} to="/about-us" onClick={handleNavClick}>
                About Us
              </Nav.Link>

              <Nav.Link as={Link} to="/contact-us" onClick={handleNavClick}>
                Contact Us
              </Nav.Link>

              <Nav.Link as={Link} to="/factory" onClick={handleNavClick}>
                Factory
              </Nav.Link>
            </Nav>

            <div className="enquire_btn_wrapper desktop">
              <Button
                className="enquire_btn"
                onClick={() => {
                  setModalShow(true);
                  setExpanded(false);
                }}
              >
                Enquire
              </Button>
            </div>
          </Navbar.Collapse>
        </div>
      </Navbar>

      <Enquire_from_modal show={modalShow} onHide={() => setModalShow(false)} />
    </section>
  );
}

export default Header;
